import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Container,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const DissertationServices: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const otherServices = [
    { title: "Dissertation", route: "/dissertation-writing-services" },
    { title: "Coursework", route: "/coursework-writing" },
    { title: "Data Analytics", route: "/data-analysis-services" },
    { title: "Project writing services", route: "/project-report-writing" },
    { title: "Publication", route: "/publication-services" },
    { title: "Literature Review", route: "/literature-review-writing" },
    { title: "Manuscript", route: "/manuscript-preparation" },
  ];

  const data = {
    icon: "ds6.webp",
    title: "Research Methodology",
    image: "ds6.webp",
    description:
      "Improve your academic presentation skills with guided coaching on structure, design, and delivery.",
    additionalInfo: [
      {
        title: "Research Design Consultation",

        icon1: "",
        description:
          "This service helps you choose the most appropriate research design for your study, such as qualitative, quantitative, or mixed methods. Consultants guide you in selecting the right framework to achieve your research objectives effectively.",
        cards: [
          {
            title: "Choosing the Right Research Approach",
            description:
              "We help you select the most suitable research approach—qualitative, quantitative, or mixed methods—based on your research objectives. This ensures your study is well-structured and aligned with your goals, whether you're exploring concepts or testing hypotheses.",
          },
          {
            title: "Defining Research Questions",

            description:
              "Our team assists in formulating clear and focused research questions that guide your study. A well-defined research question is crucial as it shapes the design, data collection, and analysis phases of your project.",
          },
          {
            title: "Developing a Research Framework",
            description:
              "We provide guidance on creating a solid research framework that outlines key variables, concepts, and relationships within your study. This framework serves as the foundation of your research and ensures that your study stays focused and coherent",
          },
          {
            title: "Ensuring Ethical Considerations",
            description:
              "Ethical compliance is essential in any research. We help you design your study with ethical considerations in mind, ensuring that your research meets institutional and industry standards for participant safety, data privacy, and integrity.",
          },
        ],
      },
      {
        title: "Data Collection Methods",
        icon1: "",
        description:
          "Support in choosing suitable data collection methods, whether through surveys, interviews, experiments, or observational studies. This ensures that the gathered data aligns with your research goals and provides reliable results.",

        cards: [
          {
            title: "Survey Design and Implementation",
            description:
              "We assist in designing surveys that gather accurate and relevant data for your research. From question formulation to distribution strategies, we ensure your surveys are clear, unbiased, and effective in collecting high-quality data.",
          },
          {
            title: "Interviews and Focus Groups",

            description:
              "Our team helps you conduct structured or semi-structured interviews and focus groups to collect in-depth qualitative data. We guide you in developing interview questions, selecting participants, and analyzing the results to uncover key insights.",
          },
          {
            title: "Observational Studies",
            description:
              "We provide support in planning and conducting observational studies, where data is gathered through direct observation of subjects. This method is particularly useful in behavioral research and offers real-time, naturalistic data collection.",
          },
          {
            title: "Experimental Data Collection",
            description:
              "For studies requiring controlled experiments, we help you design the experimental process, select the appropriate variables, and collect data accurately. This ensures that your findings are reliable, reproducible, and aligned with scientific standards.",
          },
        ],
      },
      {
        title: "Sampling Strategy Development",
        icon1: "",
        description:
          "Assistance in developing a sampling strategy, including determining the appropriate sample size, sampling techniques (random, stratified, etc.), and ensuring the sample is representative of the target population.",
        cards: [
          {
            title: "Determining Sample Size",
            description:
              "We assist you in calculating the optimal sample size for your study, ensuring that it is large enough to produce reliable results without unnecessary complexity. This step is crucial for ensuring statistical validity and reducing errors in your research findings",
          },
          {
            title: "Choosing Sampling Techniques",
            description:
              "Our experts guide you in selecting the most appropriate sampling technique, whether it's random, stratified, systematic, or convenience sampling. The right technique ensures that your sample accurately represents the population you're studying, leading to more credible results.",
          },
          {
            title: "Ensuring Representative Sampling",
            description:
              "We help ensure that your sample is representative of the broader population by focusing on key characteristics such as demographics, behaviors, or other relevant factors. This process enhances the generalizability of your study’s conclusions.",
          },
          {
            title: "Minimizing Sampling Bias",
            description:
              "We provide strategies to identify and minimize sampling bias, ensuring that your sample selection process is free from errors or distortions. Reducing bias is vital for obtaining unbiased, objective, and reliable data for your research.",
          },
        ],
      },
      {
        title: "Statistical and Analytical Support",
        icon1: "",
        description:
          "Experts help you choose the correct statistical methods or analytical techniques to analyze your data. This service ensures that your research findings are backed by rigorous and accurate analysis, boosting the validity of your study.",
        cards: [
          {
            title: "Choosing the Right Statistical Tests",
            description:
              "We help you select the most appropriate statistical tests based on your research design and data type. Whether you need t-tests, ANOVA, regression analysis, or non-parametric tests, our team ensures that your chosen methods accurately address your research questions.",
          },
          {
            title: "Data Cleaning and Preparation",

            description:
              "Our service includes thorough data cleaning and preparation to ensure your dataset is free from errors, missing values, and outliers. Properly prepared data is crucial for conducting reliable statistical analyses and drawing valid conclusions.",
          },
          {
            title: " Interpreting Statistical Results",
            description:
              "We assist in interpreting complex statistical outputs, helping you understand what the numbers mean for your research. We break down the findings into clear, actionable insights, ensuring that you can present your results confidently.",
          },
          {
            title: "Visualizing Data for Clarity",
            description:
              "Our team provides support in creating clear, impactful visualizations such as graphs, charts, and tables to showcase your statistical findings. Effective data visualization makes it easier to communicate your results to academic or professional audiences.",
          },
        ],
      },
    ],
  };
  const handleServiceClick = (route: string) => {
    window.location.href = route;
  };

  const handleHeadingClick = (index: number) => {
    setActiveIndex(activeIndex === index ? 0 : index);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: "#172554",
          padding: { sm: 0, lg: 3 },
          display: "flex",
          flexDirection: "row-reverse",
        }}
        className="component"
      >
        {/* Left Side - Other Services List (Desktop) and Expandable Headings (Mobile) */}
        <Grid item xs={12} md={3}>
          {/* Desktop View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <List>
              {data.additionalInfo.map((info, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleHeadingClick(index)}
                  selected={activeIndex === index}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={info.title} />
                </ListItem>
              ))}
              <Typography
                sx={{ textAlign: "center", color: "white", fontWeight: "bold" }}
              >
                Our Other Services
              </Typography>
              {otherServices.map((service, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleServiceClick(service.route)}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={service.title} />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Mobile View - Expandable Headings */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {data.additionalInfo.map((info, index) => (
              <Box key={index}>
                <ListItem
                  button
                  onClick={() => handleHeadingClick(index)}
                  sx={{
                    color: "white",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <ListItemText primary={info.title} />
                  <IconButton sx={{ color: "white" }}>
                    {activeIndex === index ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </ListItem>
                <Collapse
                  in={activeIndex === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "black",
                      padding: 2,
                    }}
                  >
                    <Typography variant="body2" sx={{ marginBottom: 2 }}>
                      {info.description}
                    </Typography>
                    {info.cards.map((card, cardIndex) => (
                      <Card
                        key={cardIndex}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: "#172554",
                          color: "white",
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6">
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2">
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Side - Dissertation Content (Desktop Only) */}
        <Grid item md={9} sx={{ display: { xs: "none", md: "block" } }}>
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#f3f4f6",
              boxShadow: "none",
              borderRadius: "0px",
            }}
          >
            {activeIndex !== null && (
              <>
                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                  {data.additionalInfo[activeIndex].title}
                </Typography>
                <Box sx={{ marginBottom: 2 }}></Box>
                <Typography sx={{ marginBottom: 4, textAlign: "center" }}>
                  {data.additionalInfo[activeIndex].description}
                </Typography>

                <Grid
                  container
                  direction="column"
                  spacing={2}
                  sx={{
                    backgroundColor: "#172554",
                    color: "white",
                    borderRadius: "4px",
                    maxWidth: { lg: "75%", xs: "100%" },
                  }}
                >
                  {data.additionalInfo[activeIndex].cards.map((card, index) => (
                    <Grid item key={index}>
                      <Card
                        sx={{
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "white",
                        }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6" color={"white"}>
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2" textAlign={"center"}>
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DissertationServices;
